import CustomModalDialog from '../custom-modal-dialog/custom-modal-dialog'
import { openModal, hideModal, detectBreakpoint, addClass, hasClass, select, removeClass } from '@/components/helpers/dom'
import Icon from 'snippets/icon/icon'
import { clearCart } from '@/components/helpers/cart'
import { eventProps } from 'helpers/global'
import { useState } from 'preact/hooks'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import register from 'preact-custom-element'

const selectors = {
  MODAL_CONFIRM_CLEAR_CART: 'modal-confirm-clear-cart',
  IS_MODAL_OPEN: 'is-modal-open',
  openModalClass: 'modal-dialog-opened'
}

function CartClear({ isMiniCart = false }) {
  const handleCloseModal = () => {
    if (isMiniCart) {
      const modal = select('[data-target="modal-confirm-clear-cart"]')
      modal.removeAttribute('open')
      removeClass(selectors.openModalClass, modal)
    } else {
      hideModal(selectors.MODAL_CONFIRM_CLEAR_CART)
    }
    if (!hasClass(selectors.IS_MODAL_OPEN, document.body)) {
      addClass(selectors.IS_MODAL_OPEN, document.body)
    }
  }

  return (
    <div>
      <button type="button" class={`${isMiniCart && 'absolute right-4 md:right-6 top-1/2 -translate-y-1/2'} link text-grey-500 js-btn-cart-clear`} onClick={() => openModal(selectors.MODAL_CONFIRM_CLEAR_CART)}>{detectBreakpoint() ? 'Clear' : 'Clear bag'}</button>
      <CustomModalDialog
        id={selectors.MODAL_CONFIRM_CLEAR_CART}
        type = 'modal'
        header={<ModalConfirmClearCartHeader handleCloseModal={handleCloseModal}/>}
        content={<ModalConfirmClearCartContent handleCloseModal={handleCloseModal}/>}
        classMain='!right-auto !h-fit rounded'
        className='z-100'
        classClose='hidden'
        isCartClear={isMiniCart}
      />
    </div>
  )
}

function ModalConfirmClearCartContent ({ handleCloseModal }) {
  const [isLoading, setIsLoading] = useState(false)

  const handleClearCart = async() => {
    setIsLoading(true)
    await clearCart().then(() => {
      handleCloseModal()
      globalEvents.emit(eventProps.cart.clear)
      setIsLoading(false)
    })
  }

  return (
    <div className="py-8 px-[52px] md-max:max-w-[344px] md:p-[60px] md:w-[460px]">
      <h2 class="text-lg text-grey-900 font-bold text-center">Are you sure you want to clear bag?</h2>
      <div className="flex flex-col mt-6 md:flex-row md:gap-x-4">
        <button type="button" className="button-outlined md:px-4 md:w-[calc(50%_-_8px)]" onClick={() => handleCloseModal()}>NO</button>
        <button type="button" className="md-max:mt-4 button-primary md:w-[calc(50%_-_8px)] md:px-4" onClick={handleClearCart}>{isLoading ? <LoaderSpin width={6} height={6} /> : 'YES, CLEAR BAG'}</button>
      </div>
    </div>
  )
}

function ModalConfirmClearCartHeader ({ handleCloseModal }) {
  return (
    <button type="button" className="absolute w-8 h-8 p-2 right-4 top-2 md:right-6 md:top-4" onClick={() => handleCloseModal()}>
      <Icon name="icon-close-outline-2" viewBox="0 0 20 20" className="text-grey-500 w-5 h-5" />
    </button>
  )
}

if (!customElements.get('cart-clear')) {
  register(CartClear, 'cart-clear', ['isMiniCart'])
}
